import { getStoredIdToken } from '../../../authToken';
import { config } from '../../../config/config';

const NODE_API_URL = (
  process.env.REACT_APP_NODE_API_URL ||
  config.node_api_url ||
  ''
).replace(/\/+$/, '');

export type PriceChangeLogRow = {
  id: string;
  sourceKey: string;
  sourceLabel: string;
  oldPrice: number | null;
  newPrice: number | null;
  direction: 'up' | 'down' | 'unchanged';
  createdAt: string | null;
  changedByName: string | null;
  changedByEmail: string | null;
  changedByRole: string | null;
  clientName: string | null;
  clientEmail: string | null;
  clientPricingMode: string | null;
  eventName: string | null;
  eventDate: string | null;
  venue: string | null;
  section: string | null;
  row: string | null;
  seat: string | number | null;
  tpId: string | null;
  tpStatus: string | null;
  syncStatus?: 'Success' | 'Failure' | null;
  systemsNote?: string | null;
  failureReason?: string | null;
};

export type PriceChangeLogsResponse = {
  logs: PriceChangeLogRow[];
  totalCount: number;
  limit: number;
  offset: number;
  message?: string;
};

export async function fetchPriceChangeLogs(params: {
  limit?: number;
  offset?: number;
  search?: string;
  source?: string;
  pricingMode?: string;
  syncStatus?: string;
  tpId?: string;
  tpIds?: string[];
}): Promise<PriceChangeLogsResponse> {
  const token = getStoredIdToken();
  const response = await fetch(`${NODE_API_URL}/api/listPriceChangeLogs`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      limit: params.limit ?? 50,
      offset: params.offset ?? 0,
      search: params.search || '',
      source: params.source || '',
      pricingMode: params.pricingMode || '',
      syncStatus: params.syncStatus || '',
      ...(params.tpId ? { tpId: params.tpId } : {}),
      ...(params.tpIds?.length ? { tpIds: params.tpIds } : {}),
    }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.message || 'Failed to load price change logs');
  }
  return data as PriceChangeLogsResponse;
}
